/* eslint-disable  react/prop-types */

import React from 'react';

const ChequeredFlagIcon = () => (
  <svg
    width="16"
    height="48"
    viewBox="0 0 16 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="8" y="8" width="8" height="8" fill="#045489" />
    <rect width="8" height="8" fill="#045489" />
    <rect x="8" width="8" height="8" fill="#CFEAF2" />
    <rect y="8" width="8" height="8" fill="#CFEAF2" />
    <rect x="8" y="16" width="8" height="8" fill="#CFEAF2" />
    <rect y="24" width="8" height="8" fill="#CFEAF2" />
    <rect x="8" y="32" width="8" height="8" fill="#CFEAF2" />
    <rect y="40" width="8" height="8" fill="#CFEAF2" />
    <rect y="16" width="8" height="8" fill="#045489" />
    <rect x="8" y="24" width="8" height="8" fill="#045489" />
    <rect y="32" width="8" height="8" fill="#045489" />
    <rect x="8" y="40" width="8" height="8" fill="#045489" />
  </svg>
);

export default ChequeredFlagIcon;
